<template>
  <section class="px-3 mt-3 footerStyle">
    <p class="captionStyle">
      {{ captionMessage }}
    </p>
    <b-pagination
      :value="currentPage"
      :per-page="perPage"
      :total-rows="totalRows"
      align="right"
      aria-controls="my-access-request"
      pills
      size="sm"
      @input="$emit('update:currentPage', $event)"
    ></b-pagination>
  </section>
</template>

<script>
  export default {
    props: {
      totalRows: Number,
      perPage: Number,
      currentPage: Number,
    },
    computed: {
      captionMessage() {
        let endNumber =
          this.currentPage * 10 >= this.totalRows ? this.totalRows : this.currentPage * 10;
        return `Showing ${this.currentPage * 10 - 9} - ${endNumber} of
      ${this.totalRows} results`;
      },
    },
  };
</script>

<style scoped>
  .captionStyle {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.25px;
    color: #47464e;
  }

  @media (max-width: 800px) {
    .footerStyle {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
  @media (min-width: 800px) {
    .footerStyle {
      display: flex;
      justify-content: space-between;
    }
  }
</style>
